import React from "react";

import "./index.scss";

const RecommendedSize = ({ width, height }) => {
  return (
    <div className="recommended-size mt-2">Recommended Size {width}x{height} px</div>
  );
}
export default RecommendedSize;